"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSuccessResult = exports.isResultType = exports.isErrorResult = exports.isCancelResult = exports.ShippingOfferDialogResultEvent = exports.Result = exports.Name = void 0;
const Name = exports.Name = 'shipping-offer-dialog-result';
const ShippingOfferDialogResultEvent = exports.ShippingOfferDialogResultEvent = Name;
let Result = exports.Result = /*#__PURE__*/function (Result) {
  Result[Result["Success"] = 0] = "Success";
  Result[Result["Cancel"] = 1] = "Cancel";
  Result[Result["Error"] = 2] = "Error";
  return Result;
}({});
const isResultType = (data, result) => typeof data === 'object' && data.result === result;
exports.isResultType = isResultType;
const isCancelResult = data => isResultType(data, Result.Cancel);
exports.isCancelResult = isCancelResult;
const isErrorResult = data => isResultType(data, Result.Error);
exports.isErrorResult = isErrorResult;
const isSuccessResult = data => isResultType(data, Result.Success);
exports.isSuccessResult = isSuccessResult;
//# sourceMappingURL=index.js.map